import { default as aboutaT0mIWrxp5Meta } from "/tmp/build_5560ec80/pages/[studio_url]/bundle/[bundle_id]/product/[product_id]/about.vue?macro=true";
import { default as events7MNNYGOHlIMeta } from "/tmp/build_5560ec80/pages/[studio_url]/bundle/[bundle_id]/product/[product_id]/events.vue?macro=true";
import { default as _91media_id_93jmyKKcCDvQMeta } from "/tmp/build_5560ec80/pages/[studio_url]/bundle/[bundle_id]/product/[product_id]/free-media/[media_id].vue?macro=true";
import { default as free_45sampleQ944rGPiK2Meta } from "/tmp/build_5560ec80/pages/[studio_url]/bundle/[bundle_id]/product/[product_id]/free-sample.vue?macro=true";
import { default as included_45productsnmcty8pFM0Meta } from "/tmp/build_5560ec80/pages/[studio_url]/bundle/[bundle_id]/product/[product_id]/included-products.vue?macro=true";
import { default as _91media_id_93A8LoDJIXBlMeta } from "/tmp/build_5560ec80/pages/[studio_url]/bundle/[bundle_id]/product/[product_id]/lessons/[lesson_id]/play/[media_id].vue?macro=true";
import { default as viewcEsAJJwwFnMeta } from "/tmp/build_5560ec80/pages/[studio_url]/bundle/[bundle_id]/product/[product_id]/lessons/[lesson_id]/view.vue?macro=true";
import { default as indexdQ44PGUSTXMeta } from "/tmp/build_5560ec80/pages/[studio_url]/bundle/[bundle_id]/product/[product_id]/lessons/index.vue?macro=true";
import { default as _91media_id_93XwHTlAbiCZMeta } from "/tmp/build_5560ec80/pages/[studio_url]/bundle/[bundle_id]/product/[product_id]/media/[media_id].vue?macro=true";
import { default as indexlLt2Lf7UC3Meta } from "/tmp/build_5560ec80/pages/[studio_url]/bundle/[bundle_id]/product/[product_id]/playlists/[playlist_id]/index.vue?macro=true";
import { default as _91media_id_93C18VFOfV03Meta } from "/tmp/build_5560ec80/pages/[studio_url]/bundle/[bundle_id]/product/[product_id]/playlists/[playlist_id]/media/[media_id].vue?macro=true";
import { default as indexBG48V0xsGcMeta } from "/tmp/build_5560ec80/pages/[studio_url]/bundle/[bundle_id]/product/[product_id]/playlists/index.vue?macro=true";
import { default as private_45sessionsQ7JzhLbjceMeta } from "/tmp/build_5560ec80/pages/[studio_url]/bundle/[bundle_id]/product/[product_id]/private-sessions.vue?macro=true";
import { default as recordingsbmTOPOYgOgMeta } from "/tmp/build_5560ec80/pages/[studio_url]/bundle/[bundle_id]/product/[product_id]/recordings.vue?macro=true";
import { default as reviews2D5dUMsWC8Meta } from "/tmp/build_5560ec80/pages/[studio_url]/bundle/[bundle_id]/product/[product_id]/reviews.vue?macro=true";
import { default as _91product_id_93ctuEiZ6bcJMeta } from "/tmp/build_5560ec80/pages/[studio_url]/bundle/[bundle_id]/product/[product_id].vue?macro=true";
import { default as indexmGQEHDLGopMeta } from "/tmp/build_5560ec80/pages/[studio_url]/buy/product/[product_id]/index.vue?macro=true";
import { default as confirmbd0qJP6YrtMeta } from "/tmp/build_5560ec80/pages/[studio_url]/buy/product/[product_id]/paypal/confirm.vue?macro=true";
import { default as confirmVx1oMkNCdiMeta } from "/tmp/build_5560ec80/pages/[studio_url]/buy/product/[product_id]/stripe/confirm.vue?macro=true";
import { default as calendarXE1iLGWaZoMeta } from "/tmp/build_5560ec80/pages/[studio_url]/calendar.vue?macro=true";
import { default as chatkcjj4aYSIFMeta } from "/tmp/build_5560ec80/pages/[studio_url]/chat.vue?macro=true";
import { default as abouteMUSL8bC5dMeta } from "/tmp/build_5560ec80/pages/[studio_url]/community-groups/[group_id]/about.vue?macro=true";
import { default as feedQ7hFH6ABg9Meta } from "/tmp/build_5560ec80/pages/[studio_url]/community-groups/[group_id]/feed.vue?macro=true";
import { default as membershLpZIQ7FXdMeta } from "/tmp/build_5560ec80/pages/[studio_url]/community-groups/[group_id]/members.vue?macro=true";
import { default as _91group_id_93s7j8VxXhx9Meta } from "/tmp/build_5560ec80/pages/[studio_url]/community-groups/[group_id].vue?macro=true";
import { default as community_45profile_45edit7y74HfI438Meta } from "/tmp/build_5560ec80/pages/[studio_url]/community-profile-edit.vue?macro=true";
import { default as _91id_93HmdbEcFyOJMeta } from "/tmp/build_5560ec80/pages/[studio_url]/community-profile/[id].vue?macro=true";
import { default as communityp1TzZHIwRbMeta } from "/tmp/build_5560ec80/pages/[studio_url]/community.vue?macro=true";
import { default as _91uuid_93Bil4aqKCPkMeta } from "/tmp/build_5560ec80/pages/[studio_url]/complete-registration/[uuid].vue?macro=true";
import { default as _91unique_id_93yGs4IaCLklMeta } from "/tmp/build_5560ec80/pages/[studio_url]/contracts/[unique_id].vue?macro=true";
import { default as dashboardAGZqRvpkrHMeta } from "/tmp/build_5560ec80/pages/[studio_url]/dashboard.vue?macro=true";
import { default as indexXyBEpAiszNMeta } from "/tmp/build_5560ec80/pages/[studio_url]/event/details/[event_id]/index.vue?macro=true";
import { default as checkoutuErXPXd9BGMeta } from "/tmp/build_5560ec80/pages/[studio_url]/event/details/[event_id]/product/[product_id]/checkout.vue?macro=true";
import { default as select_45productqNrR6wOdbxMeta } from "/tmp/build_5560ec80/pages/[studio_url]/event/details/[event_id]/select-product.vue?macro=true";
import { default as eventswE1oIaXfbMMeta } from "/tmp/build_5560ec80/pages/[studio_url]/events.vue?macro=true";
import { default as _91uuid_93k1WbplYqZZMeta } from "/tmp/build_5560ec80/pages/[studio_url]/gifts/[uuid].vue?macro=true";
import { default as indexBMWLo4yxhwMeta } from "/tmp/build_5560ec80/pages/[studio_url]/gifts/index.vue?macro=true";
import { default as _91invitation_id_93pAfrndzLyEMeta } from "/tmp/build_5560ec80/pages/[studio_url]/gifts/invitation/[invitation_id].vue?macro=true";
import { default as _91product_id_93gWzLMRhdkNMeta } from "/tmp/build_5560ec80/pages/[studio_url]/gifts/product/[product_id].vue?macro=true";
import { default as indexSJgdfjDb2YMeta } from "/tmp/build_5560ec80/pages/[studio_url]/index.vue?macro=true";
import { default as _91invitation_unique_id_93HXumGQJmX7Meta } from "/tmp/build_5560ec80/pages/[studio_url]/invitation/[invitation_unique_id].vue?macro=true";
import { default as joinnxBWv4uU1LMeta } from "/tmp/build_5560ec80/pages/[studio_url]/join.vue?macro=true";
import { default as login5UVF4oVSqjMeta } from "/tmp/build_5560ec80/pages/[studio_url]/login.vue?macro=true";
import { default as logouthqIRWKqW2rMeta } from "/tmp/build_5560ec80/pages/[studio_url]/logout.vue?macro=true";
import { default as _91meeting_type_slug_93ZNC7WsVbuNMeta } from "/tmp/build_5560ec80/pages/[studio_url]/meet/[meeting_type_slug].vue?macro=true";
import { default as _91meeting_unique_id_93G1xzAP6n0FMeta } from "/tmp/build_5560ec80/pages/[studio_url]/meet/[meeting_unique_id].vue?macro=true";
import { default as _91meeting_unique_id_93HTbU7cdEzpMeta } from "/tmp/build_5560ec80/pages/[studio_url]/meeting/[meeting_unique_id].vue?macro=true";
import { default as my_45favoritessOwNrxzZHtMeta } from "/tmp/build_5560ec80/pages/[studio_url]/my-favorites.vue?macro=true";
import { default as my_45studios7B5NYjsBNFMeta } from "/tmp/build_5560ec80/pages/[studio_url]/my-studios.vue?macro=true";
import { default as optinxaH62oUO5ZMeta } from "/tmp/build_5560ec80/pages/[studio_url]/optin.vue?macro=true";
import { default as _91episode_id_93n8TmVlk1rtMeta } from "/tmp/build_5560ec80/pages/[studio_url]/podcasts/[podcast_id]/episodes/[episode_id].vue?macro=true";
import { default as indexIoeicBBAZPMeta } from "/tmp/build_5560ec80/pages/[studio_url]/podcasts/[podcast_id]/index.vue?macro=true";
import { default as indexoA1ofOzEicMeta } from "/tmp/build_5560ec80/pages/[studio_url]/podcasts/index.vue?macro=true";
import { default as aboutrVrbeeu06ZMeta } from "/tmp/build_5560ec80/pages/[studio_url]/product/[product_id]/about.vue?macro=true";
import { default as digital_45download_45contentJ8oZ9qDs6eMeta } from "/tmp/build_5560ec80/pages/[studio_url]/product/[product_id]/digital-download-content.vue?macro=true";
import { default as eventssXvgreTxo5Meta } from "/tmp/build_5560ec80/pages/[studio_url]/product/[product_id]/events.vue?macro=true";
import { default as _91media_id_935hWJXmPbSmMeta } from "/tmp/build_5560ec80/pages/[studio_url]/product/[product_id]/free-media/[media_id].vue?macro=true";
import { default as free_45samplewRMmEo0mSlMeta } from "/tmp/build_5560ec80/pages/[studio_url]/product/[product_id]/free-sample.vue?macro=true";
import { default as included_45productsLZxijpeZGNMeta } from "/tmp/build_5560ec80/pages/[studio_url]/product/[product_id]/included-products.vue?macro=true";
import { default as _91media_id_93WUOxq0ADsqMeta } from "/tmp/build_5560ec80/pages/[studio_url]/product/[product_id]/lessons/[lesson_id]/play/[media_id].vue?macro=true";
import { default as viewNm9JK85brvMeta } from "/tmp/build_5560ec80/pages/[studio_url]/product/[product_id]/lessons/[lesson_id]/view.vue?macro=true";
import { default as index7NtRzYBuhkMeta } from "/tmp/build_5560ec80/pages/[studio_url]/product/[product_id]/lessons/index.vue?macro=true";
import { default as _91media_id_93dAQe6Kb4D5Meta } from "/tmp/build_5560ec80/pages/[studio_url]/product/[product_id]/media/[media_id].vue?macro=true";
import { default as indexehQUjWqgbLMeta } from "/tmp/build_5560ec80/pages/[studio_url]/product/[product_id]/playlists/[playlist_id]/index.vue?macro=true";
import { default as _91media_id_93eP3Mn1lRdKMeta } from "/tmp/build_5560ec80/pages/[studio_url]/product/[product_id]/playlists/[playlist_id]/media/[media_id].vue?macro=true";
import { default as index3ly3AIldIrMeta } from "/tmp/build_5560ec80/pages/[studio_url]/product/[product_id]/playlists/index.vue?macro=true";
import { default as private_45sessionsATiGQ25H39Meta } from "/tmp/build_5560ec80/pages/[studio_url]/product/[product_id]/private-sessions.vue?macro=true";
import { default as recordingsx5J2AMgkRXMeta } from "/tmp/build_5560ec80/pages/[studio_url]/product/[product_id]/recordings.vue?macro=true";
import { default as reviewsS4YuwFjEalMeta } from "/tmp/build_5560ec80/pages/[studio_url]/product/[product_id]/reviews.vue?macro=true";
import { default as _91product_id_937WKiLBN0RSMeta } from "/tmp/build_5560ec80/pages/[studio_url]/product/[product_id].vue?macro=true";
import { default as index26QsdYb2nOMeta } from "/tmp/build_5560ec80/pages/[studio_url]/product/index.vue?macro=true";
import { default as indexnihLX7CEFlMeta } from "/tmp/build_5560ec80/pages/[studio_url]/profile/index.vue?macro=true";
import { default as purchasesXGGjOHjg3jMeta } from "/tmp/build_5560ec80/pages/[studio_url]/profile/purchases.vue?macro=true";
import { default as redemptionswDEV5d6WeCMeta } from "/tmp/build_5560ec80/pages/[studio_url]/profile/redemptions.vue?macro=true";
import { default as _91quiz_id_93MZnKyxxJWnMeta } from "/tmp/build_5560ec80/pages/[studio_url]/quiz/[quiz_id].vue?macro=true";
import { default as _91token_93k0Gu4YWtDfMeta } from "/tmp/build_5560ec80/pages/[studio_url]/reset-password/[uid]/[token].vue?macro=true";
import { default as resettFDBVOEFDQMeta } from "/tmp/build_5560ec80/pages/[studio_url]/reset.vue?macro=true";
import { default as shoptoSitBTIeSMeta } from "/tmp/build_5560ec80/pages/[studio_url]/shop.vue?macro=true";
import { default as signuprhYBY6WezsMeta } from "/tmp/build_5560ec80/pages/[studio_url]/signup.vue?macro=true";
import { default as liveMDDTGfvqt6Meta } from "/tmp/build_5560ec80/pages/[studio_url]/streaming/[event_id]/live.vue?macro=true";
import { default as tipsiMVg20x03SMeta } from "/tmp/build_5560ec80/pages/[studio_url]/tips.vue?macro=true";
import { default as _91uuid_93wBX5SqXksDMeta } from "/tmp/build_5560ec80/pages/[studio_url]/waiver/[uuid].vue?macro=true";
import { default as compactA6PDbGOxKPMeta } from "/tmp/build_5560ec80/pages/[studio_url]/widgets/calendars/compact.vue?macro=true";
import { default as fullzZSNBzUZcsMeta } from "/tmp/build_5560ec80/pages/[studio_url]/widgets/calendars/full.vue?macro=true";
export default [
  {
    name: _91product_id_93ctuEiZ6bcJMeta?.name ?? "bundle-bundle_id-product-product_id",
    path: _91product_id_93ctuEiZ6bcJMeta?.path ?? "/bundle/:bundle_id()/product/:product_id()",
    meta: _91product_id_93ctuEiZ6bcJMeta || {},
    alias: _91product_id_93ctuEiZ6bcJMeta?.alias || [],
    redirect: _91product_id_93ctuEiZ6bcJMeta?.redirect,
    component: () => import("/tmp/build_5560ec80/pages/[studio_url]/bundle/[bundle_id]/product/[product_id].vue").then(m => m.default || m),
    children: [
  {
    name: aboutaT0mIWrxp5Meta?.name ?? "bundle-bundle_id-product-product_id-about",
    path: aboutaT0mIWrxp5Meta?.path ?? "about",
    meta: aboutaT0mIWrxp5Meta || {},
    alias: aboutaT0mIWrxp5Meta?.alias || [],
    redirect: aboutaT0mIWrxp5Meta?.redirect,
    component: () => import("/tmp/build_5560ec80/pages/[studio_url]/bundle/[bundle_id]/product/[product_id]/about.vue").then(m => m.default || m)
  },
  {
    name: events7MNNYGOHlIMeta?.name ?? "bundle-bundle_id-product-product_id-events",
    path: events7MNNYGOHlIMeta?.path ?? "events",
    meta: events7MNNYGOHlIMeta || {},
    alias: events7MNNYGOHlIMeta?.alias || [],
    redirect: events7MNNYGOHlIMeta?.redirect,
    component: () => import("/tmp/build_5560ec80/pages/[studio_url]/bundle/[bundle_id]/product/[product_id]/events.vue").then(m => m.default || m)
  },
  {
    name: _91media_id_93jmyKKcCDvQMeta?.name ?? "bundle-bundle_id-product-product_id-free-media-media_id",
    path: _91media_id_93jmyKKcCDvQMeta?.path ?? "free-media/:media_id()",
    meta: _91media_id_93jmyKKcCDvQMeta || {},
    alias: _91media_id_93jmyKKcCDvQMeta?.alias || [],
    redirect: _91media_id_93jmyKKcCDvQMeta?.redirect,
    component: () => import("/tmp/build_5560ec80/pages/[studio_url]/bundle/[bundle_id]/product/[product_id]/free-media/[media_id].vue").then(m => m.default || m)
  },
  {
    name: free_45sampleQ944rGPiK2Meta?.name ?? "bundle-bundle_id-product-product_id-free-sample",
    path: free_45sampleQ944rGPiK2Meta?.path ?? "free-sample",
    meta: free_45sampleQ944rGPiK2Meta || {},
    alias: free_45sampleQ944rGPiK2Meta?.alias || [],
    redirect: free_45sampleQ944rGPiK2Meta?.redirect,
    component: () => import("/tmp/build_5560ec80/pages/[studio_url]/bundle/[bundle_id]/product/[product_id]/free-sample.vue").then(m => m.default || m)
  },
  {
    name: included_45productsnmcty8pFM0Meta?.name ?? "bundle-bundle_id-product-product_id-included-products",
    path: included_45productsnmcty8pFM0Meta?.path ?? "included-products",
    meta: included_45productsnmcty8pFM0Meta || {},
    alias: included_45productsnmcty8pFM0Meta?.alias || [],
    redirect: included_45productsnmcty8pFM0Meta?.redirect,
    component: () => import("/tmp/build_5560ec80/pages/[studio_url]/bundle/[bundle_id]/product/[product_id]/included-products.vue").then(m => m.default || m)
  },
  {
    name: _91media_id_93A8LoDJIXBlMeta?.name ?? "bundle-bundle_id-product-product_id-lessons-lesson_id-play-media_id",
    path: _91media_id_93A8LoDJIXBlMeta?.path ?? "lessons/:lesson_id()/play/:media_id()",
    meta: _91media_id_93A8LoDJIXBlMeta || {},
    alias: _91media_id_93A8LoDJIXBlMeta?.alias || [],
    redirect: _91media_id_93A8LoDJIXBlMeta?.redirect,
    component: () => import("/tmp/build_5560ec80/pages/[studio_url]/bundle/[bundle_id]/product/[product_id]/lessons/[lesson_id]/play/[media_id].vue").then(m => m.default || m)
  },
  {
    name: viewcEsAJJwwFnMeta?.name ?? "bundle-bundle_id-product-product_id-lessons-lesson_id-view",
    path: viewcEsAJJwwFnMeta?.path ?? "lessons/:lesson_id()/view",
    meta: viewcEsAJJwwFnMeta || {},
    alias: viewcEsAJJwwFnMeta?.alias || [],
    redirect: viewcEsAJJwwFnMeta?.redirect,
    component: () => import("/tmp/build_5560ec80/pages/[studio_url]/bundle/[bundle_id]/product/[product_id]/lessons/[lesson_id]/view.vue").then(m => m.default || m)
  },
  {
    name: indexdQ44PGUSTXMeta?.name ?? "bundle-bundle_id-product-product_id-lessons",
    path: indexdQ44PGUSTXMeta?.path ?? "lessons",
    meta: indexdQ44PGUSTXMeta || {},
    alias: indexdQ44PGUSTXMeta?.alias || [],
    redirect: indexdQ44PGUSTXMeta?.redirect,
    component: () => import("/tmp/build_5560ec80/pages/[studio_url]/bundle/[bundle_id]/product/[product_id]/lessons/index.vue").then(m => m.default || m)
  },
  {
    name: _91media_id_93XwHTlAbiCZMeta?.name ?? "bundle-bundle_id-product-product_id-media-media_id",
    path: _91media_id_93XwHTlAbiCZMeta?.path ?? "media/:media_id()",
    meta: _91media_id_93XwHTlAbiCZMeta || {},
    alias: _91media_id_93XwHTlAbiCZMeta?.alias || [],
    redirect: _91media_id_93XwHTlAbiCZMeta?.redirect,
    component: () => import("/tmp/build_5560ec80/pages/[studio_url]/bundle/[bundle_id]/product/[product_id]/media/[media_id].vue").then(m => m.default || m)
  },
  {
    name: indexlLt2Lf7UC3Meta?.name ?? "bundle-bundle_id-product-product_id-playlists-playlist_id",
    path: indexlLt2Lf7UC3Meta?.path ?? "playlists/:playlist_id()",
    meta: indexlLt2Lf7UC3Meta || {},
    alias: indexlLt2Lf7UC3Meta?.alias || [],
    redirect: indexlLt2Lf7UC3Meta?.redirect,
    component: () => import("/tmp/build_5560ec80/pages/[studio_url]/bundle/[bundle_id]/product/[product_id]/playlists/[playlist_id]/index.vue").then(m => m.default || m)
  },
  {
    name: _91media_id_93C18VFOfV03Meta?.name ?? "bundle-bundle_id-product-product_id-playlists-playlist_id-media-media_id",
    path: _91media_id_93C18VFOfV03Meta?.path ?? "playlists/:playlist_id()/media/:media_id()",
    meta: _91media_id_93C18VFOfV03Meta || {},
    alias: _91media_id_93C18VFOfV03Meta?.alias || [],
    redirect: _91media_id_93C18VFOfV03Meta?.redirect,
    component: () => import("/tmp/build_5560ec80/pages/[studio_url]/bundle/[bundle_id]/product/[product_id]/playlists/[playlist_id]/media/[media_id].vue").then(m => m.default || m)
  },
  {
    name: indexBG48V0xsGcMeta?.name ?? "bundle-bundle_id-product-product_id-playlists",
    path: indexBG48V0xsGcMeta?.path ?? "playlists",
    meta: indexBG48V0xsGcMeta || {},
    alias: indexBG48V0xsGcMeta?.alias || [],
    redirect: indexBG48V0xsGcMeta?.redirect,
    component: () => import("/tmp/build_5560ec80/pages/[studio_url]/bundle/[bundle_id]/product/[product_id]/playlists/index.vue").then(m => m.default || m)
  },
  {
    name: private_45sessionsQ7JzhLbjceMeta?.name ?? "bundle-bundle_id-product-product_id-private-sessions",
    path: private_45sessionsQ7JzhLbjceMeta?.path ?? "private-sessions",
    meta: private_45sessionsQ7JzhLbjceMeta || {},
    alias: private_45sessionsQ7JzhLbjceMeta?.alias || [],
    redirect: private_45sessionsQ7JzhLbjceMeta?.redirect,
    component: () => import("/tmp/build_5560ec80/pages/[studio_url]/bundle/[bundle_id]/product/[product_id]/private-sessions.vue").then(m => m.default || m)
  },
  {
    name: recordingsbmTOPOYgOgMeta?.name ?? "bundle-bundle_id-product-product_id-recordings",
    path: recordingsbmTOPOYgOgMeta?.path ?? "recordings",
    meta: recordingsbmTOPOYgOgMeta || {},
    alias: recordingsbmTOPOYgOgMeta?.alias || [],
    redirect: recordingsbmTOPOYgOgMeta?.redirect,
    component: () => import("/tmp/build_5560ec80/pages/[studio_url]/bundle/[bundle_id]/product/[product_id]/recordings.vue").then(m => m.default || m)
  },
  {
    name: reviews2D5dUMsWC8Meta?.name ?? "bundle-bundle_id-product-product_id-reviews",
    path: reviews2D5dUMsWC8Meta?.path ?? "reviews",
    meta: reviews2D5dUMsWC8Meta || {},
    alias: reviews2D5dUMsWC8Meta?.alias || [],
    redirect: reviews2D5dUMsWC8Meta?.redirect,
    component: () => import("/tmp/build_5560ec80/pages/[studio_url]/bundle/[bundle_id]/product/[product_id]/reviews.vue").then(m => m.default || m)
  }
]
  },
  {
    name: indexmGQEHDLGopMeta?.name ?? "buy-product-product_id",
    path: indexmGQEHDLGopMeta?.path ?? "/buy/product/:product_id()",
    meta: indexmGQEHDLGopMeta || {},
    alias: indexmGQEHDLGopMeta?.alias || [],
    redirect: indexmGQEHDLGopMeta?.redirect,
    component: () => import("/tmp/build_5560ec80/pages/[studio_url]/buy/product/[product_id]/index.vue").then(m => m.default || m)
  },
  {
    name: confirmbd0qJP6YrtMeta?.name ?? "buy-product-product_id-paypal-confirm",
    path: confirmbd0qJP6YrtMeta?.path ?? "/buy/product/:product_id()/paypal/confirm",
    meta: confirmbd0qJP6YrtMeta || {},
    alias: confirmbd0qJP6YrtMeta?.alias || [],
    redirect: confirmbd0qJP6YrtMeta?.redirect,
    component: () => import("/tmp/build_5560ec80/pages/[studio_url]/buy/product/[product_id]/paypal/confirm.vue").then(m => m.default || m)
  },
  {
    name: confirmVx1oMkNCdiMeta?.name ?? "buy-product-product_id-stripe-confirm",
    path: confirmVx1oMkNCdiMeta?.path ?? "/buy/product/:product_id()/stripe/confirm",
    meta: confirmVx1oMkNCdiMeta || {},
    alias: confirmVx1oMkNCdiMeta?.alias || [],
    redirect: confirmVx1oMkNCdiMeta?.redirect,
    component: () => import("/tmp/build_5560ec80/pages/[studio_url]/buy/product/[product_id]/stripe/confirm.vue").then(m => m.default || m)
  },
  {
    name: calendarXE1iLGWaZoMeta?.name ?? "calendar",
    path: calendarXE1iLGWaZoMeta?.path ?? "/calendar",
    meta: calendarXE1iLGWaZoMeta || {},
    alias: calendarXE1iLGWaZoMeta?.alias || [],
    redirect: calendarXE1iLGWaZoMeta?.redirect,
    component: () => import("/tmp/build_5560ec80/pages/[studio_url]/calendar.vue").then(m => m.default || m)
  },
  {
    name: chatkcjj4aYSIFMeta?.name ?? "chat",
    path: chatkcjj4aYSIFMeta?.path ?? "/chat",
    meta: chatkcjj4aYSIFMeta || {},
    alias: chatkcjj4aYSIFMeta?.alias || [],
    redirect: chatkcjj4aYSIFMeta?.redirect,
    component: () => import("/tmp/build_5560ec80/pages/[studio_url]/chat.vue").then(m => m.default || m)
  },
  {
    name: _91group_id_93s7j8VxXhx9Meta?.name ?? "community-groups-group_id",
    path: _91group_id_93s7j8VxXhx9Meta?.path ?? "/community-groups/:group_id()",
    meta: _91group_id_93s7j8VxXhx9Meta || {},
    alias: _91group_id_93s7j8VxXhx9Meta?.alias || [],
    redirect: _91group_id_93s7j8VxXhx9Meta?.redirect,
    component: () => import("/tmp/build_5560ec80/pages/[studio_url]/community-groups/[group_id].vue").then(m => m.default || m),
    children: [
  {
    name: abouteMUSL8bC5dMeta?.name ?? "community-groups-group_id-about",
    path: abouteMUSL8bC5dMeta?.path ?? "about",
    meta: abouteMUSL8bC5dMeta || {},
    alias: abouteMUSL8bC5dMeta?.alias || [],
    redirect: abouteMUSL8bC5dMeta?.redirect,
    component: () => import("/tmp/build_5560ec80/pages/[studio_url]/community-groups/[group_id]/about.vue").then(m => m.default || m)
  },
  {
    name: feedQ7hFH6ABg9Meta?.name ?? "community-groups-group_id-feed",
    path: feedQ7hFH6ABg9Meta?.path ?? "feed",
    meta: feedQ7hFH6ABg9Meta || {},
    alias: feedQ7hFH6ABg9Meta?.alias || [],
    redirect: feedQ7hFH6ABg9Meta?.redirect,
    component: () => import("/tmp/build_5560ec80/pages/[studio_url]/community-groups/[group_id]/feed.vue").then(m => m.default || m)
  },
  {
    name: membershLpZIQ7FXdMeta?.name ?? "community-groups-group_id-members",
    path: membershLpZIQ7FXdMeta?.path ?? "members",
    meta: membershLpZIQ7FXdMeta || {},
    alias: membershLpZIQ7FXdMeta?.alias || [],
    redirect: membershLpZIQ7FXdMeta?.redirect,
    component: () => import("/tmp/build_5560ec80/pages/[studio_url]/community-groups/[group_id]/members.vue").then(m => m.default || m)
  }
]
  },
  {
    name: community_45profile_45edit7y74HfI438Meta?.name ?? "community-profile-edit",
    path: community_45profile_45edit7y74HfI438Meta?.path ?? "/community-profile-edit",
    meta: community_45profile_45edit7y74HfI438Meta || {},
    alias: community_45profile_45edit7y74HfI438Meta?.alias || [],
    redirect: community_45profile_45edit7y74HfI438Meta?.redirect,
    component: () => import("/tmp/build_5560ec80/pages/[studio_url]/community-profile-edit.vue").then(m => m.default || m)
  },
  {
    name: _91id_93HmdbEcFyOJMeta?.name ?? "community-profile-id",
    path: _91id_93HmdbEcFyOJMeta?.path ?? "/community-profile/:id()",
    meta: _91id_93HmdbEcFyOJMeta || {},
    alias: _91id_93HmdbEcFyOJMeta?.alias || [],
    redirect: _91id_93HmdbEcFyOJMeta?.redirect,
    component: () => import("/tmp/build_5560ec80/pages/[studio_url]/community-profile/[id].vue").then(m => m.default || m)
  },
  {
    name: communityp1TzZHIwRbMeta?.name ?? "community",
    path: communityp1TzZHIwRbMeta?.path ?? "/community",
    meta: communityp1TzZHIwRbMeta || {},
    alias: communityp1TzZHIwRbMeta?.alias || [],
    redirect: communityp1TzZHIwRbMeta?.redirect,
    component: () => import("/tmp/build_5560ec80/pages/[studio_url]/community.vue").then(m => m.default || m)
  },
  {
    name: _91uuid_93Bil4aqKCPkMeta?.name ?? "complete-registration-uuid",
    path: _91uuid_93Bil4aqKCPkMeta?.path ?? "/complete-registration/:uuid()",
    meta: _91uuid_93Bil4aqKCPkMeta || {},
    alias: _91uuid_93Bil4aqKCPkMeta?.alias || [],
    redirect: _91uuid_93Bil4aqKCPkMeta?.redirect,
    component: () => import("/tmp/build_5560ec80/pages/[studio_url]/complete-registration/[uuid].vue").then(m => m.default || m)
  },
  {
    name: _91unique_id_93yGs4IaCLklMeta?.name ?? "contracts-unique_id",
    path: _91unique_id_93yGs4IaCLklMeta?.path ?? "/contracts/:unique_id()",
    meta: _91unique_id_93yGs4IaCLklMeta || {},
    alias: _91unique_id_93yGs4IaCLklMeta?.alias || [],
    redirect: _91unique_id_93yGs4IaCLklMeta?.redirect,
    component: () => import("/tmp/build_5560ec80/pages/[studio_url]/contracts/[unique_id].vue").then(m => m.default || m)
  },
  {
    name: dashboardAGZqRvpkrHMeta?.name ?? "dashboard",
    path: dashboardAGZqRvpkrHMeta?.path ?? "/dashboard",
    meta: dashboardAGZqRvpkrHMeta || {},
    alias: dashboardAGZqRvpkrHMeta?.alias || [],
    redirect: dashboardAGZqRvpkrHMeta?.redirect,
    component: () => import("/tmp/build_5560ec80/pages/[studio_url]/dashboard.vue").then(m => m.default || m)
  },
  {
    name: indexXyBEpAiszNMeta?.name ?? "event-details-event_id",
    path: indexXyBEpAiszNMeta?.path ?? "/event/details/:event_id()",
    meta: indexXyBEpAiszNMeta || {},
    alias: indexXyBEpAiszNMeta?.alias || [],
    redirect: indexXyBEpAiszNMeta?.redirect,
    component: () => import("/tmp/build_5560ec80/pages/[studio_url]/event/details/[event_id]/index.vue").then(m => m.default || m)
  },
  {
    name: checkoutuErXPXd9BGMeta?.name ?? "event-details-event_id-product-product_id-checkout",
    path: checkoutuErXPXd9BGMeta?.path ?? "/event/details/:event_id()/product/:product_id()/checkout",
    meta: checkoutuErXPXd9BGMeta || {},
    alias: checkoutuErXPXd9BGMeta?.alias || [],
    redirect: checkoutuErXPXd9BGMeta?.redirect,
    component: () => import("/tmp/build_5560ec80/pages/[studio_url]/event/details/[event_id]/product/[product_id]/checkout.vue").then(m => m.default || m)
  },
  {
    name: select_45productqNrR6wOdbxMeta?.name ?? "event-details-event_id-select-product",
    path: select_45productqNrR6wOdbxMeta?.path ?? "/event/details/:event_id()/select-product",
    meta: select_45productqNrR6wOdbxMeta || {},
    alias: select_45productqNrR6wOdbxMeta?.alias || [],
    redirect: select_45productqNrR6wOdbxMeta?.redirect,
    component: () => import("/tmp/build_5560ec80/pages/[studio_url]/event/details/[event_id]/select-product.vue").then(m => m.default || m)
  },
  {
    name: eventswE1oIaXfbMMeta?.name ?? "events",
    path: eventswE1oIaXfbMMeta?.path ?? "/events",
    meta: eventswE1oIaXfbMMeta || {},
    alias: eventswE1oIaXfbMMeta?.alias || [],
    redirect: eventswE1oIaXfbMMeta?.redirect,
    component: () => import("/tmp/build_5560ec80/pages/[studio_url]/events.vue").then(m => m.default || m)
  },
  {
    name: _91uuid_93k1WbplYqZZMeta?.name ?? "gifts-uuid",
    path: _91uuid_93k1WbplYqZZMeta?.path ?? "/gifts/:uuid()",
    meta: _91uuid_93k1WbplYqZZMeta || {},
    alias: _91uuid_93k1WbplYqZZMeta?.alias || [],
    redirect: _91uuid_93k1WbplYqZZMeta?.redirect,
    component: () => import("/tmp/build_5560ec80/pages/[studio_url]/gifts/[uuid].vue").then(m => m.default || m)
  },
  {
    name: indexBMWLo4yxhwMeta?.name ?? "gifts",
    path: indexBMWLo4yxhwMeta?.path ?? "/gifts",
    meta: indexBMWLo4yxhwMeta || {},
    alias: indexBMWLo4yxhwMeta?.alias || [],
    redirect: indexBMWLo4yxhwMeta?.redirect,
    component: () => import("/tmp/build_5560ec80/pages/[studio_url]/gifts/index.vue").then(m => m.default || m)
  },
  {
    name: _91invitation_id_93pAfrndzLyEMeta?.name ?? "gifts-invitation-invitation_id",
    path: _91invitation_id_93pAfrndzLyEMeta?.path ?? "/gifts/invitation/:invitation_id()",
    meta: _91invitation_id_93pAfrndzLyEMeta || {},
    alias: _91invitation_id_93pAfrndzLyEMeta?.alias || [],
    redirect: _91invitation_id_93pAfrndzLyEMeta?.redirect,
    component: () => import("/tmp/build_5560ec80/pages/[studio_url]/gifts/invitation/[invitation_id].vue").then(m => m.default || m)
  },
  {
    name: _91product_id_93gWzLMRhdkNMeta?.name ?? "gifts-product-product_id",
    path: _91product_id_93gWzLMRhdkNMeta?.path ?? "/gifts/product/:product_id()",
    meta: _91product_id_93gWzLMRhdkNMeta || {},
    alias: _91product_id_93gWzLMRhdkNMeta?.alias || [],
    redirect: _91product_id_93gWzLMRhdkNMeta?.redirect,
    component: () => import("/tmp/build_5560ec80/pages/[studio_url]/gifts/product/[product_id].vue").then(m => m.default || m)
  },
  {
    name: indexSJgdfjDb2YMeta?.name ?? "index",
    path: indexSJgdfjDb2YMeta?.path ?? "/",
    meta: indexSJgdfjDb2YMeta || {},
    alias: indexSJgdfjDb2YMeta?.alias || [],
    redirect: indexSJgdfjDb2YMeta?.redirect,
    component: () => import("/tmp/build_5560ec80/pages/[studio_url]/index.vue").then(m => m.default || m)
  },
  {
    name: _91invitation_unique_id_93HXumGQJmX7Meta?.name ?? "invitation-invitation_unique_id",
    path: _91invitation_unique_id_93HXumGQJmX7Meta?.path ?? "/invitation/:invitation_unique_id()",
    meta: _91invitation_unique_id_93HXumGQJmX7Meta || {},
    alias: _91invitation_unique_id_93HXumGQJmX7Meta?.alias || [],
    redirect: _91invitation_unique_id_93HXumGQJmX7Meta?.redirect,
    component: () => import("/tmp/build_5560ec80/pages/[studio_url]/invitation/[invitation_unique_id].vue").then(m => m.default || m)
  },
  {
    name: joinnxBWv4uU1LMeta?.name ?? "join",
    path: joinnxBWv4uU1LMeta?.path ?? "/join",
    meta: joinnxBWv4uU1LMeta || {},
    alias: joinnxBWv4uU1LMeta?.alias || [],
    redirect: joinnxBWv4uU1LMeta?.redirect,
    component: () => import("/tmp/build_5560ec80/pages/[studio_url]/join.vue").then(m => m.default || m)
  },
  {
    name: login5UVF4oVSqjMeta?.name ?? "login",
    path: login5UVF4oVSqjMeta?.path ?? "/login",
    meta: login5UVF4oVSqjMeta || {},
    alias: login5UVF4oVSqjMeta?.alias || [],
    redirect: login5UVF4oVSqjMeta?.redirect,
    component: () => import("/tmp/build_5560ec80/pages/[studio_url]/login.vue").then(m => m.default || m)
  },
  {
    name: logouthqIRWKqW2rMeta?.name ?? "logout",
    path: logouthqIRWKqW2rMeta?.path ?? "/logout",
    meta: logouthqIRWKqW2rMeta || {},
    alias: logouthqIRWKqW2rMeta?.alias || [],
    redirect: logouthqIRWKqW2rMeta?.redirect,
    component: () => import("/tmp/build_5560ec80/pages/[studio_url]/logout.vue").then(m => m.default || m)
  },
  {
    name: _91meeting_type_slug_93ZNC7WsVbuNMeta?.name ?? "meet-meeting_type_slug",
    path: _91meeting_type_slug_93ZNC7WsVbuNMeta?.path ?? "/meet/:meeting_type_slug()",
    meta: _91meeting_type_slug_93ZNC7WsVbuNMeta || {},
    alias: _91meeting_type_slug_93ZNC7WsVbuNMeta?.alias || [],
    redirect: _91meeting_type_slug_93ZNC7WsVbuNMeta?.redirect,
    component: () => import("/tmp/build_5560ec80/pages/[studio_url]/meet/[meeting_type_slug].vue").then(m => m.default || m)
  },
  {
    name: _91meeting_unique_id_93G1xzAP6n0FMeta?.name ?? "meet-meeting_unique_id",
    path: _91meeting_unique_id_93G1xzAP6n0FMeta?.path ?? "/meet/:meeting_unique_id()",
    meta: _91meeting_unique_id_93G1xzAP6n0FMeta || {},
    alias: _91meeting_unique_id_93G1xzAP6n0FMeta?.alias || [],
    redirect: _91meeting_unique_id_93G1xzAP6n0FMeta?.redirect,
    component: () => import("/tmp/build_5560ec80/pages/[studio_url]/meet/[meeting_unique_id].vue").then(m => m.default || m)
  },
  {
    name: _91meeting_unique_id_93HTbU7cdEzpMeta?.name ?? "meeting-meeting_unique_id",
    path: _91meeting_unique_id_93HTbU7cdEzpMeta?.path ?? "/meeting/:meeting_unique_id()",
    meta: _91meeting_unique_id_93HTbU7cdEzpMeta || {},
    alias: _91meeting_unique_id_93HTbU7cdEzpMeta?.alias || [],
    redirect: _91meeting_unique_id_93HTbU7cdEzpMeta?.redirect,
    component: () => import("/tmp/build_5560ec80/pages/[studio_url]/meeting/[meeting_unique_id].vue").then(m => m.default || m)
  },
  {
    name: my_45favoritessOwNrxzZHtMeta?.name ?? "my-favorites",
    path: my_45favoritessOwNrxzZHtMeta?.path ?? "/my-favorites",
    meta: my_45favoritessOwNrxzZHtMeta || {},
    alias: my_45favoritessOwNrxzZHtMeta?.alias || [],
    redirect: my_45favoritessOwNrxzZHtMeta?.redirect,
    component: () => import("/tmp/build_5560ec80/pages/[studio_url]/my-favorites.vue").then(m => m.default || m)
  },
  {
    name: my_45studios7B5NYjsBNFMeta?.name ?? "my-studios",
    path: my_45studios7B5NYjsBNFMeta?.path ?? "/my-studios",
    meta: my_45studios7B5NYjsBNFMeta || {},
    alias: my_45studios7B5NYjsBNFMeta?.alias || [],
    redirect: my_45studios7B5NYjsBNFMeta?.redirect,
    component: () => import("/tmp/build_5560ec80/pages/[studio_url]/my-studios.vue").then(m => m.default || m)
  },
  {
    name: optinxaH62oUO5ZMeta?.name ?? "optin",
    path: optinxaH62oUO5ZMeta?.path ?? "/optin",
    meta: optinxaH62oUO5ZMeta || {},
    alias: optinxaH62oUO5ZMeta?.alias || [],
    redirect: optinxaH62oUO5ZMeta?.redirect,
    component: () => import("/tmp/build_5560ec80/pages/[studio_url]/optin.vue").then(m => m.default || m)
  },
  {
    name: _91episode_id_93n8TmVlk1rtMeta?.name ?? "podcasts-podcast_id-episodes-episode_id",
    path: _91episode_id_93n8TmVlk1rtMeta?.path ?? "/podcasts/:podcast_id()/episodes/:episode_id()",
    meta: _91episode_id_93n8TmVlk1rtMeta || {},
    alias: _91episode_id_93n8TmVlk1rtMeta?.alias || [],
    redirect: _91episode_id_93n8TmVlk1rtMeta?.redirect,
    component: () => import("/tmp/build_5560ec80/pages/[studio_url]/podcasts/[podcast_id]/episodes/[episode_id].vue").then(m => m.default || m)
  },
  {
    name: indexIoeicBBAZPMeta?.name ?? "podcasts-podcast_id",
    path: indexIoeicBBAZPMeta?.path ?? "/podcasts/:podcast_id()",
    meta: indexIoeicBBAZPMeta || {},
    alias: indexIoeicBBAZPMeta?.alias || [],
    redirect: indexIoeicBBAZPMeta?.redirect,
    component: () => import("/tmp/build_5560ec80/pages/[studio_url]/podcasts/[podcast_id]/index.vue").then(m => m.default || m)
  },
  {
    name: indexoA1ofOzEicMeta?.name ?? "podcasts",
    path: indexoA1ofOzEicMeta?.path ?? "/podcasts",
    meta: indexoA1ofOzEicMeta || {},
    alias: indexoA1ofOzEicMeta?.alias || [],
    redirect: indexoA1ofOzEicMeta?.redirect,
    component: () => import("/tmp/build_5560ec80/pages/[studio_url]/podcasts/index.vue").then(m => m.default || m)
  },
  {
    name: _91product_id_937WKiLBN0RSMeta?.name ?? "product-product_id",
    path: _91product_id_937WKiLBN0RSMeta?.path ?? "/product/:product_id()",
    meta: _91product_id_937WKiLBN0RSMeta || {},
    alias: _91product_id_937WKiLBN0RSMeta?.alias || [],
    redirect: _91product_id_937WKiLBN0RSMeta?.redirect,
    component: () => import("/tmp/build_5560ec80/pages/[studio_url]/product/[product_id].vue").then(m => m.default || m),
    children: [
  {
    name: aboutrVrbeeu06ZMeta?.name ?? "product-product_id-about",
    path: aboutrVrbeeu06ZMeta?.path ?? "about",
    meta: aboutrVrbeeu06ZMeta || {},
    alias: aboutrVrbeeu06ZMeta?.alias || [],
    redirect: aboutrVrbeeu06ZMeta?.redirect,
    component: () => import("/tmp/build_5560ec80/pages/[studio_url]/product/[product_id]/about.vue").then(m => m.default || m)
  },
  {
    name: digital_45download_45contentJ8oZ9qDs6eMeta?.name ?? "product-product_id-digital-download-content",
    path: digital_45download_45contentJ8oZ9qDs6eMeta?.path ?? "digital-download-content",
    meta: digital_45download_45contentJ8oZ9qDs6eMeta || {},
    alias: digital_45download_45contentJ8oZ9qDs6eMeta?.alias || [],
    redirect: digital_45download_45contentJ8oZ9qDs6eMeta?.redirect,
    component: () => import("/tmp/build_5560ec80/pages/[studio_url]/product/[product_id]/digital-download-content.vue").then(m => m.default || m)
  },
  {
    name: eventssXvgreTxo5Meta?.name ?? "product-product_id-events",
    path: eventssXvgreTxo5Meta?.path ?? "events",
    meta: eventssXvgreTxo5Meta || {},
    alias: eventssXvgreTxo5Meta?.alias || [],
    redirect: eventssXvgreTxo5Meta?.redirect,
    component: () => import("/tmp/build_5560ec80/pages/[studio_url]/product/[product_id]/events.vue").then(m => m.default || m)
  },
  {
    name: _91media_id_935hWJXmPbSmMeta?.name ?? "product-product_id-free-media-media_id",
    path: _91media_id_935hWJXmPbSmMeta?.path ?? "free-media/:media_id()",
    meta: _91media_id_935hWJXmPbSmMeta || {},
    alias: _91media_id_935hWJXmPbSmMeta?.alias || [],
    redirect: _91media_id_935hWJXmPbSmMeta?.redirect,
    component: () => import("/tmp/build_5560ec80/pages/[studio_url]/product/[product_id]/free-media/[media_id].vue").then(m => m.default || m)
  },
  {
    name: free_45samplewRMmEo0mSlMeta?.name ?? "product-product_id-free-sample",
    path: free_45samplewRMmEo0mSlMeta?.path ?? "free-sample",
    meta: free_45samplewRMmEo0mSlMeta || {},
    alias: free_45samplewRMmEo0mSlMeta?.alias || [],
    redirect: free_45samplewRMmEo0mSlMeta?.redirect,
    component: () => import("/tmp/build_5560ec80/pages/[studio_url]/product/[product_id]/free-sample.vue").then(m => m.default || m)
  },
  {
    name: included_45productsLZxijpeZGNMeta?.name ?? "product-product_id-included-products",
    path: included_45productsLZxijpeZGNMeta?.path ?? "included-products",
    meta: included_45productsLZxijpeZGNMeta || {},
    alias: included_45productsLZxijpeZGNMeta?.alias || [],
    redirect: included_45productsLZxijpeZGNMeta?.redirect,
    component: () => import("/tmp/build_5560ec80/pages/[studio_url]/product/[product_id]/included-products.vue").then(m => m.default || m)
  },
  {
    name: _91media_id_93WUOxq0ADsqMeta?.name ?? "product-product_id-lessons-lesson_id-play-media_id",
    path: _91media_id_93WUOxq0ADsqMeta?.path ?? "lessons/:lesson_id()/play/:media_id()",
    meta: _91media_id_93WUOxq0ADsqMeta || {},
    alias: _91media_id_93WUOxq0ADsqMeta?.alias || [],
    redirect: _91media_id_93WUOxq0ADsqMeta?.redirect,
    component: () => import("/tmp/build_5560ec80/pages/[studio_url]/product/[product_id]/lessons/[lesson_id]/play/[media_id].vue").then(m => m.default || m)
  },
  {
    name: viewNm9JK85brvMeta?.name ?? "product-product_id-lessons-lesson_id-view",
    path: viewNm9JK85brvMeta?.path ?? "lessons/:lesson_id()/view",
    meta: viewNm9JK85brvMeta || {},
    alias: viewNm9JK85brvMeta?.alias || [],
    redirect: viewNm9JK85brvMeta?.redirect,
    component: () => import("/tmp/build_5560ec80/pages/[studio_url]/product/[product_id]/lessons/[lesson_id]/view.vue").then(m => m.default || m)
  },
  {
    name: index7NtRzYBuhkMeta?.name ?? "product-product_id-lessons",
    path: index7NtRzYBuhkMeta?.path ?? "lessons",
    meta: index7NtRzYBuhkMeta || {},
    alias: index7NtRzYBuhkMeta?.alias || [],
    redirect: index7NtRzYBuhkMeta?.redirect,
    component: () => import("/tmp/build_5560ec80/pages/[studio_url]/product/[product_id]/lessons/index.vue").then(m => m.default || m)
  },
  {
    name: _91media_id_93dAQe6Kb4D5Meta?.name ?? "product-product_id-media-media_id",
    path: _91media_id_93dAQe6Kb4D5Meta?.path ?? "media/:media_id()",
    meta: _91media_id_93dAQe6Kb4D5Meta || {},
    alias: _91media_id_93dAQe6Kb4D5Meta?.alias || [],
    redirect: _91media_id_93dAQe6Kb4D5Meta?.redirect,
    component: () => import("/tmp/build_5560ec80/pages/[studio_url]/product/[product_id]/media/[media_id].vue").then(m => m.default || m)
  },
  {
    name: indexehQUjWqgbLMeta?.name ?? "product-product_id-playlists-playlist_id",
    path: indexehQUjWqgbLMeta?.path ?? "playlists/:playlist_id()",
    meta: indexehQUjWqgbLMeta || {},
    alias: indexehQUjWqgbLMeta?.alias || [],
    redirect: indexehQUjWqgbLMeta?.redirect,
    component: () => import("/tmp/build_5560ec80/pages/[studio_url]/product/[product_id]/playlists/[playlist_id]/index.vue").then(m => m.default || m)
  },
  {
    name: _91media_id_93eP3Mn1lRdKMeta?.name ?? "product-product_id-playlists-playlist_id-media-media_id",
    path: _91media_id_93eP3Mn1lRdKMeta?.path ?? "playlists/:playlist_id()/media/:media_id()",
    meta: _91media_id_93eP3Mn1lRdKMeta || {},
    alias: _91media_id_93eP3Mn1lRdKMeta?.alias || [],
    redirect: _91media_id_93eP3Mn1lRdKMeta?.redirect,
    component: () => import("/tmp/build_5560ec80/pages/[studio_url]/product/[product_id]/playlists/[playlist_id]/media/[media_id].vue").then(m => m.default || m)
  },
  {
    name: index3ly3AIldIrMeta?.name ?? "product-product_id-playlists",
    path: index3ly3AIldIrMeta?.path ?? "playlists",
    meta: index3ly3AIldIrMeta || {},
    alias: index3ly3AIldIrMeta?.alias || [],
    redirect: index3ly3AIldIrMeta?.redirect,
    component: () => import("/tmp/build_5560ec80/pages/[studio_url]/product/[product_id]/playlists/index.vue").then(m => m.default || m)
  },
  {
    name: private_45sessionsATiGQ25H39Meta?.name ?? "product-product_id-private-sessions",
    path: private_45sessionsATiGQ25H39Meta?.path ?? "private-sessions",
    meta: private_45sessionsATiGQ25H39Meta || {},
    alias: private_45sessionsATiGQ25H39Meta?.alias || [],
    redirect: private_45sessionsATiGQ25H39Meta?.redirect,
    component: () => import("/tmp/build_5560ec80/pages/[studio_url]/product/[product_id]/private-sessions.vue").then(m => m.default || m)
  },
  {
    name: recordingsx5J2AMgkRXMeta?.name ?? "product-product_id-recordings",
    path: recordingsx5J2AMgkRXMeta?.path ?? "recordings",
    meta: recordingsx5J2AMgkRXMeta || {},
    alias: recordingsx5J2AMgkRXMeta?.alias || [],
    redirect: recordingsx5J2AMgkRXMeta?.redirect,
    component: () => import("/tmp/build_5560ec80/pages/[studio_url]/product/[product_id]/recordings.vue").then(m => m.default || m)
  },
  {
    name: reviewsS4YuwFjEalMeta?.name ?? "product-product_id-reviews",
    path: reviewsS4YuwFjEalMeta?.path ?? "reviews",
    meta: reviewsS4YuwFjEalMeta || {},
    alias: reviewsS4YuwFjEalMeta?.alias || [],
    redirect: reviewsS4YuwFjEalMeta?.redirect,
    component: () => import("/tmp/build_5560ec80/pages/[studio_url]/product/[product_id]/reviews.vue").then(m => m.default || m)
  }
]
  },
  {
    name: index26QsdYb2nOMeta?.name ?? "product",
    path: index26QsdYb2nOMeta?.path ?? "/product",
    meta: index26QsdYb2nOMeta || {},
    alias: index26QsdYb2nOMeta?.alias || [],
    redirect: index26QsdYb2nOMeta?.redirect,
    component: () => import("/tmp/build_5560ec80/pages/[studio_url]/product/index.vue").then(m => m.default || m)
  },
  {
    name: indexnihLX7CEFlMeta?.name ?? "profile",
    path: indexnihLX7CEFlMeta?.path ?? "/profile",
    meta: indexnihLX7CEFlMeta || {},
    alias: indexnihLX7CEFlMeta?.alias || [],
    redirect: indexnihLX7CEFlMeta?.redirect,
    component: () => import("/tmp/build_5560ec80/pages/[studio_url]/profile/index.vue").then(m => m.default || m)
  },
  {
    name: purchasesXGGjOHjg3jMeta?.name ?? "profile-purchases",
    path: purchasesXGGjOHjg3jMeta?.path ?? "/profile/purchases",
    meta: purchasesXGGjOHjg3jMeta || {},
    alias: purchasesXGGjOHjg3jMeta?.alias || [],
    redirect: purchasesXGGjOHjg3jMeta?.redirect,
    component: () => import("/tmp/build_5560ec80/pages/[studio_url]/profile/purchases.vue").then(m => m.default || m)
  },
  {
    name: redemptionswDEV5d6WeCMeta?.name ?? "profile-redemptions",
    path: redemptionswDEV5d6WeCMeta?.path ?? "/profile/redemptions",
    meta: redemptionswDEV5d6WeCMeta || {},
    alias: redemptionswDEV5d6WeCMeta?.alias || [],
    redirect: redemptionswDEV5d6WeCMeta?.redirect,
    component: () => import("/tmp/build_5560ec80/pages/[studio_url]/profile/redemptions.vue").then(m => m.default || m)
  },
  {
    name: _91quiz_id_93MZnKyxxJWnMeta?.name ?? "quiz-quiz_id",
    path: _91quiz_id_93MZnKyxxJWnMeta?.path ?? "/quiz/:quiz_id()",
    meta: _91quiz_id_93MZnKyxxJWnMeta || {},
    alias: _91quiz_id_93MZnKyxxJWnMeta?.alias || [],
    redirect: _91quiz_id_93MZnKyxxJWnMeta?.redirect,
    component: () => import("/tmp/build_5560ec80/pages/[studio_url]/quiz/[quiz_id].vue").then(m => m.default || m)
  },
  {
    name: _91token_93k0Gu4YWtDfMeta?.name ?? "reset-password-uid-token",
    path: _91token_93k0Gu4YWtDfMeta?.path ?? "/reset-password/:uid()/:token()",
    meta: _91token_93k0Gu4YWtDfMeta || {},
    alias: _91token_93k0Gu4YWtDfMeta?.alias || [],
    redirect: _91token_93k0Gu4YWtDfMeta?.redirect,
    component: () => import("/tmp/build_5560ec80/pages/[studio_url]/reset-password/[uid]/[token].vue").then(m => m.default || m)
  },
  {
    name: resettFDBVOEFDQMeta?.name ?? "reset",
    path: resettFDBVOEFDQMeta?.path ?? "/reset",
    meta: resettFDBVOEFDQMeta || {},
    alias: resettFDBVOEFDQMeta?.alias || [],
    redirect: resettFDBVOEFDQMeta?.redirect,
    component: () => import("/tmp/build_5560ec80/pages/[studio_url]/reset.vue").then(m => m.default || m)
  },
  {
    name: shoptoSitBTIeSMeta?.name ?? "shop",
    path: shoptoSitBTIeSMeta?.path ?? "/shop",
    meta: shoptoSitBTIeSMeta || {},
    alias: shoptoSitBTIeSMeta?.alias || [],
    redirect: shoptoSitBTIeSMeta?.redirect,
    component: () => import("/tmp/build_5560ec80/pages/[studio_url]/shop.vue").then(m => m.default || m)
  },
  {
    name: signuprhYBY6WezsMeta?.name ?? "signup",
    path: signuprhYBY6WezsMeta?.path ?? "/signup",
    meta: signuprhYBY6WezsMeta || {},
    alias: signuprhYBY6WezsMeta?.alias || [],
    redirect: signuprhYBY6WezsMeta?.redirect,
    component: () => import("/tmp/build_5560ec80/pages/[studio_url]/signup.vue").then(m => m.default || m)
  },
  {
    name: liveMDDTGfvqt6Meta?.name ?? "streaming-event_id-live",
    path: liveMDDTGfvqt6Meta?.path ?? "/streaming/:event_id()/live",
    meta: liveMDDTGfvqt6Meta || {},
    alias: liveMDDTGfvqt6Meta?.alias || [],
    redirect: liveMDDTGfvqt6Meta?.redirect,
    component: () => import("/tmp/build_5560ec80/pages/[studio_url]/streaming/[event_id]/live.vue").then(m => m.default || m)
  },
  {
    name: tipsiMVg20x03SMeta?.name ?? "tips",
    path: tipsiMVg20x03SMeta?.path ?? "/tips",
    meta: tipsiMVg20x03SMeta || {},
    alias: tipsiMVg20x03SMeta?.alias || [],
    redirect: tipsiMVg20x03SMeta?.redirect,
    component: () => import("/tmp/build_5560ec80/pages/[studio_url]/tips.vue").then(m => m.default || m)
  },
  {
    name: _91uuid_93wBX5SqXksDMeta?.name ?? "waiver-uuid",
    path: _91uuid_93wBX5SqXksDMeta?.path ?? "/waiver/:uuid()",
    meta: _91uuid_93wBX5SqXksDMeta || {},
    alias: _91uuid_93wBX5SqXksDMeta?.alias || [],
    redirect: _91uuid_93wBX5SqXksDMeta?.redirect,
    component: () => import("/tmp/build_5560ec80/pages/[studio_url]/waiver/[uuid].vue").then(m => m.default || m)
  },
  {
    name: compactA6PDbGOxKPMeta?.name ?? "widgets-calendars-compact",
    path: compactA6PDbGOxKPMeta?.path ?? "/widgets/calendars/compact",
    meta: compactA6PDbGOxKPMeta || {},
    alias: compactA6PDbGOxKPMeta?.alias || [],
    redirect: compactA6PDbGOxKPMeta?.redirect,
    component: () => import("/tmp/build_5560ec80/pages/[studio_url]/widgets/calendars/compact.vue").then(m => m.default || m)
  },
  {
    name: fullzZSNBzUZcsMeta?.name ?? "widgets-calendars-full",
    path: fullzZSNBzUZcsMeta?.path ?? "/widgets/calendars/full",
    meta: fullzZSNBzUZcsMeta || {},
    alias: fullzZSNBzUZcsMeta?.alias || [],
    redirect: fullzZSNBzUZcsMeta?.redirect,
    component: () => import("/tmp/build_5560ec80/pages/[studio_url]/widgets/calendars/full.vue").then(m => m.default || m)
  }
]